// Pure helper: did a request fail at the network level (no response at all)?
const NETWORK_MESSAGE_PATTERNS = [
  /failed to fetch/i,
  /network request failed/i,
  /networkerror when attempting to fetch/i,
  /load failed/i,
];

export function isNetworkFailure(err) {
  if (typeof navigator !== "undefined" && navigator && navigator.onLine === false) {
    return true;
  }
  const message = String(err?.message || "");
  return NETWORK_MESSAGE_PATTERNS.some((re) => re.test(message));
}
